import { useNavigate } from "react-router-dom";

interface Props {
  show: boolean;
  onClose: () => void;
}

export const SuccessModal = (props: Props) => {
  const { show, onClose } = props;
  const navigate = useNavigate();

  if (!show) return null;

  const handleComplete = () => {
    onClose();
    navigate(-1); // 前の画面に戻る
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full">
        <h2 className="text-2xl font-bold mb-4">修正が完了しました</h2>
        <p className="text-gray-600 mb-6">シフトの修正が正常に完了しました。</p>
        <div className="flex justify-end">
          <button
            type="button"
            onClick={handleComplete}
            className="bg-[#00AF31] text-white rounded-md px-6 py-2 font-bold"
          >
            完了
          </button>
        </div>
      </div>
    </div>
  );
};
